import styled, { createGlobalStyle } from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: ${(props) => (props.isMobile ? "100%" : "auto")};
  height: 100%;
`;

export const BaseWrapper = styled.div`
  position: relative;
  background-color: ${(props) => props.backgroundColor || "#fff"};
  border-radius: 40px 40px 0 0;
  padding: 10px;
  bottom: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  z-index: 1000;
  overscroll-behavior: contain;
  touch-action: none;
  animation: MoveUpDown 0.3s linear;
  font-family: Arial, Helvetica, sans-serif;

  .nav-footer {
    margin-top: 30px;
    margin-bottom: 5px;

    .footer-first-item {
      font-size: 8px;
      color: #474657;
      font-weight: 400;
      line-height: 10px;
      display: flex;
      justify-content: center;

      a {
        margin-left: 5px;
        display: block;
      }
    }

    .footer-last-item {
      font-size: 8px;
      color: #474657;
      font-weight: 400;
      line-height: 10px;
      margin-top: 5px;

      a {
        color: #5b66ea;
        text-decoration: none;
        margin-left: 2px;
      }
    }
  }
`;

export const HeaderBorder = styled.div`
  background-color: #f0f1f4;
  border-radius: 9px;
  height: 6px;
  width: 44px;
`;

export const LogoContainer = styled.div`
  margin: 45px 0 29px 0;
  width: 189px;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: auto;
    max-height: 118px;
    object-fit: contain;
  }
`;

export const TitleContainer = styled.div`
  max-width: 98%;
  margin: 0 auto;
`;

export const Title = styled.div`
  width: 100%;
  white-space: normal;
  word-break: break-word;
  font-weight: bold;
  line-height: 22px;
  font-size: 23px;
  letter-spacing: 0.86px;
  color: ${(props) => props.color};
`;

export const DescriptionContainer = styled.div`
  max-width: 90%;
  margin: 0 auto;
  margin-top: 11px;
`;

export const Description = styled.div`
  width: 100%;
  white-space: normal;
  word-break: break-word;
  font-weight: 400;
  line-height: 20px;
  font-size: 14px;
  color: ${(props) => props.color};
`;

export const ButtonContainer = styled.div`
  width: 325px;
  margin: 0 auto;
  margin-top: 23px;
  padding: 0 3px;

  .swipe-to-start-button {
    width: 100%;
    height: 70px;
    position: relative;
    border-radius: 100px;
    display: flex;
    align-items: center;
    overflow: hidden;
    z-index: 10;
  }

  .swipe-to-start-button-animation {
    animation: nudge 3s ease-in-out infinite;
  }

  .icon-with-text {
    padding: 7px;
    border-radius: 100px;
    display: flex;
    align-items: center;

    .icon-wrapper {
      height: 56px;
      min-width: 56px;
      background-color: #fff;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-right: 3px;
      position: absolute;
      animation: linear infinite;
      animation-name: run;
      animation-duration: 2.5s;
    }

    .text {
      text-align: center;
      color: #fff;
      font-weight: 600;
      width: 100%;
    }
  }
`;

export const CloseButton = styled.div`
  padding: 10px;
  cursor: pointer;
  right: ${(props) => (props.isDesktop ? "15px" : "20px")};
  top: ${(props) => (props.isDesktop ? "10px" : "15px")};
  position: absolute;
`;

export const ThankYouContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 87px;
  width: 325px;
  animation: fadeIn 1s ease forwards;
`;

export const ThankYouText = styled.p`
  margin: 0;
  color: ${(props) => props.color};
  font-size: ${(props) => props.fontSize}px;
  font-weight: 600;
  margin-left: 5px;
  margin-bottom: 3px;
`;

// Add keyframe animations
export const GlobalStyles = createGlobalStyle`
  @keyframes MoveUpDown {
    0% { transform: translateY(1000px); }
    100% { transform: translateY(0); }
  }

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  @keyframes nudge {
    0% { transform: rotate(0deg); }
    10% { transform: rotate(0deg); }
    25% { transform: rotate(-2deg); }
    50% { transform: rotate(2deg); }
    75% { transform: rotate(0deg); }
    100% { transform: rotate(0deg); }
  }
`;
